function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-177.998 -226.779)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1,10.017l-.013.013V10c-1.151-1.147-6.844-4.04-6-7.293C1.653-2.151,5.846.971,6.1,1.166c.253-.195,4.443-3.316,6.012,1.546.844,3.252-4.848,6.146-6,7.293v.024Z",
  transform: "translate(182.72 227.283)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.967,263.8l3.126,3.608,1.7-2.644a2.273,2.273,0,0,1,2.053-1.275c1.369.124,4.043.591,5.909-1.089s3.857-2.985,5.07-4.386,3.483-3.3,1.9-3.826c-.373-.031-.809,0-3.235,2.27a9.807,9.807,0,0,1-6.843,3.141c-3.875-.669-1.244-1.493-.155-1.991s1.772-.995,1.679-1.586c-.124-.373-.4-.934-3.981.435-1.376.547-2.508.155-3.734,1.247-.9.718-.663,3.276-2.922,5.13C179.308,263.251,178.967,263.8,178.967,263.8Z",
  transform: "translate(-0.35 -14.798)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.793,277.687c-.817-1.076-2.952-4.019-2.952-4.019a1.9,1.9,0,0,0-1.463,1.731c-.034.466,2.854,4.118,3.378,4.09A2.248,2.248,0,0,0,182.793,277.687Z",
  transform: "translate(0 -26.376)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M631.107,154.26a12.41,12.41,0,0,0,4.313-2.706c1.294-1.576,4.61-3.962,4.367-2.466",
  transform: "translate(-442.29 90.508)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeLinecap: "round",
  strokeWidth: 1
}));

var SvgSelfServe = function SvgSelfServe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "self-serve",
    width: 21.414,
    height: 26.665,
    viewBox: "0 0 21.414 26.665",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelfServe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/self-serve.76fc08fe.svg";
export { ForwardRef as ReactComponent };